import { useTranslation } from "react-i18next";
import "./GenericErrorMessage.scss";

export const GenericErrorMessage: React.FC = () => {
  const { t } = useTranslation();
  return <p className="generic-error-message">{t("errors.generic")}</p>;
};
